import PropTypes from 'prop-types'
import React from 'react'

const XAxisTick = ({ data, index, x, y }) => {
  const item = data[index]

  return (
    <g transform={`translate(${x},${y})`}>
      {item.xAxisLabel &&
        item.xAxisLabel.map((series, idx) => (
          <text
            // eslint-disable-next-line react/no-array-index-key
            key={`axis-label-${idx}`}
            x={0}
            y={0}
            dy={12 * idx + 7}
            textAnchor="middle"
          >
            {series}
          </text>
        ))}
    </g>
  )
}

XAxisTick.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      xAxisLabel: PropTypes.array,
    }),
  ).isRequired,
  index: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
}

export default XAxisTick
